import { Component, Input, ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-bciti-tab',
    styleUrls: ['./tab.component.scss'],
    template: `
        <div [hidden]="!active" class="pane">
            <ng-content></ng-content>
        </div>
    `,
})
export class BcitiTabComponent {
    constructor(private cdr: ChangeDetectorRef) {}

    public _active = false;

    @Input() title: string;

    @Input() pluginId: string;

    @Input()
    set active(state: boolean) {
        this._active = state;
        this.cdr.detectChanges();
    }

    get active(): boolean {
        return this._active;
    }
}
